import { render, staticRenderFns } from "./DiscountListForStoreView.vue?vue&type=template&id=482fd89b&scoped=true"
import script from "./DiscountListForStoreView.vue?vue&type=script&lang=js"
export * from "./DiscountListForStoreView.vue?vue&type=script&lang=js"
import style0 from "./DiscountListForStoreView.vue?vue&type=style&index=0&id=482fd89b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fd89b",
  null
  
)

export default component.exports